module.exports = __webpack_public_path__ + "static/media/location.c36bc45b.svg";